export const STATE_PERSIST_KEY = 'online-trade-in';
export const SESSION_ID_KEY = `${STATE_PERSIST_KEY}-session`;
